import styled from "@emotion/styled";
import Colors from "styles/colors";
import { BRAND_BLACK_TEXT_COLOR, WHITE_COLOR_NAME } from "styles/color-consts";
const CHECK_BOX_COLOR = "#0073ea";
const SELECTED_VALUE_COLOR = "#cce5ff";
export const StyledFilter = styled.div`
  display: flex;
  flex-direction: column;
  margin: 12px;
  border-radius: 4px;

  .filter-value {
    position: relative;

    .select-container {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 12px;
      font-size: 0.875rem;
      border-radius: 4px;
      width: 100%;
      border-radius: 8px;
      border: 1px solid;
      border-color: ${Colors.gainsboro};
      cursor: pointer;
      min-height: 46px;

      .down-arrow-wrapper {
        margin-right: 12px;
        transition: transform 0.3s ease-in-out;

        .down-arrow {
          width: 8px;
          height: 8px;
        }

        &.open {
          transform: rotate(180deg);
          position: relative;
        }
      }

      .selected-values {
        display: flex;
        align-items: center;
        max-width: 380px;
        overflow: hidden;

        .ellipsis {
          font-size: 0.875rem;
          padding: 8px;
          background-color: ${SELECTED_VALUE_COLOR};
          color: ${Colors[BRAND_BLACK_TEXT_COLOR]};
          border-radius: 8px;
          margin: 8px 8px 8px 0;
        }

        .filter-selected {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 8px 8px;
          background-color: ${SELECTED_VALUE_COLOR};
          color: ${Colors[BRAND_BLACK_TEXT_COLOR]};
          border-radius: 8px;
          font-size: 0.875rem;
          margin: 8px 8px 8px 0;
          max-height: 35px;

          .close-button {
            margin-left: 8px;
            cursor: pointer;

            svg {
              height: 8px;
            }
          }

          &:hover .close-button {
            color: black;
          }
        }
      }

      .placeholder {
        color: ${Colors["mud"]};
        padding-left: 8px;

        &.open {
          font-weight: 500;
        }
      }

      .arrow-down {
        width: 0;
        height: 0;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-top: 8px solid black;
        margin-right: 8px;
      }

      &:hover {
        background-color: ${Colors["white-smoke"]};
      }

      &.open {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
    }

    .options-container {
      top: 100%;
      left: 0;
      z-index: 1;
      display: none;
      flex-direction: column;
      background-color: ${Colors[WHITE_COLOR_NAME]};
      border-top: none;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      overflow-y: auto;
      max-height: 300px;
      width: 100%;
      position: relative;
      padding-top: 12px;
      padding-bottom: 12px;

      .option {
        padding: 8px 12px;
        font-size: 0.875rem;
        line-height: 20px;
        cursor: pointer;
        text-align: left;
        display: flex;
        margin: 4px 8px;
        border-radius: 8px;

        &:hover {
          background-color: ${Colors["white-smoke"]};
        }

        &.selected {
          background-color: ${Colors["white-smoke"]};
        }

        .icon {
          padding-right: 4px;
          width: 26px;
          
          .asset-inner .picture-component img {
            object-fit: contain;
            max-height: 20px;
          }
        }

        .checkbox {
          display: flex;
          width: 20px;
          height: 20px;
          border: 1px solid;
          border-color: ${Colors.gainsboro};
          border-radius: 3px;
          margin-right: 8px;
          cursor: pointer;
          align-items: center;

          .v-sign {
            padding: 2px;
            display: none;

            svg {
              max-height: 9px;
            }
          }
        }

        .checkbox.selected {
          background-color: ${CHECK_BOX_COLOR};
          text-align: center;
        }

        .checkbox.selected .v-sign {
          display: unset;
        }
      }
    }

    .options-container::before {
      content: "";
      position: absolute;
      top: 0;
      left: 20px;
      width: calc(100% - 40px);
      height: 0.5px;
      background-color: ${Colors["gainsboro"]};
    }

    &.open {
      .options-container {
        display: flex;
      }

      .select-container {
        border: none;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
  }

  &.open {
    box-shadow: 0 2px 6px 0 rgba(29, 140, 242, 0.16);
    border-color: ${Colors.gainsboro};
  }

  &.hide {
    display: none;
  }
`;
